import { c as createCommonjsModule } from '../../../common/_commonjsHelpers-64249c85.js';
import { r as react } from '../../../common/index-3eed8459.js';
import '../../../common/setPrototypeOf-8347dfab.js';
import '../../../common/extends-1379b0c5.js';
import '../../../common/objectWithoutPropertiesLoose-fe69c3b9.js';
import '../../../common/process-2545f00a.js';
import '../../../common/slicedToArray-f17eab12.js';
import '../../../common/unsupportedIterableToArray-b4606a71.js';
import '../../../common/typeof-818d02f5.js';
import '../../../common/defineProperty-89b82966.js';
import '../../../common/warning-25054749.js';
import '../../../common/objectSpread2-6043052c.js';
import '../../../common/possibleConstructorReturn-6665475e.js';
import '../../../common/createSuper-ffd29211.js';
import '../../../common/toConsumableArray-feb56514.js';
import '../../../common/index-2e7abe66.js';
import '../../../common/toArray-8084f789.js';
import { e as es } from '../../../common/index-b623b0e6.js';
import '../../../common/asyncToGenerator-c9162921.js';
import { i as interopRequireDefault } from '../../../common/interopRequireDefault-6e0c2256.js';
import { i as interopRequireWildcard } from '../../../common/objectSpread2-c7bbc689.js';
import { o as omit_1 } from '../../../common/omit-c904a63c.js';

var context = createCommonjsModule(function (module, exports) {





Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormItemPrefixContext = exports.FormProvider = exports.FormItemContext = exports.FormContext = void 0;

var React = interopRequireWildcard(react);

var _omit = interopRequireDefault(omit_1);



var FormContext = /*#__PURE__*/React.createContext({
  labelAlign: 'right',
  vertical: false,
  itemRef: function itemRef() {}
});
exports.FormContext = FormContext;
var FormItemContext = /*#__PURE__*/React.createContext({
  updateItemErrors: function updateItemErrors() {}
});
exports.FormItemContext = FormItemContext;

var FormProvider = function FormProvider(props) {
  var providerProps = (0, _omit["default"])(props, ['prefixCls']);
  return /*#__PURE__*/React.createElement(es.FormProvider, providerProps);
};

exports.FormProvider = FormProvider;
var FormItemPrefixContext = /*#__PURE__*/React.createContext({
  prefixCls: ''
});
exports.FormItemPrefixContext = FormItemPrefixContext;
});

var FormProvider = context.FormProvider;
export { FormProvider };
